var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYardAutonomousGates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M20.7 7.2h1v9.6h-1zM4.8 7.2h1v13.4h-1zM3.4 21.3h17.1v1H3.4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M12.2 20.5h-1v-1.7H8.7v1.7h-1v-2.7h4.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M12.2 17.2h-1v-1.8H8.7v1.8h-1v-2.8h4.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M23.5 22.3H20v-4.8h3.4v4.8zm-2.5-1h1.4v-2.8H21z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M20.7 18.5c-.1 0-.2 0-.2-.1L7.9 11.5c-.2-.1-.3-.4-.2-.7s.4-.3.7-.2L21 17.5c.2.1.3.4.2.7-.1.2-.3.3-.5.3"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M23.4 6.7H3.3v-3h20.2v3zm-19.1-1h18.2v-1H4.3z"
})));
export default SvgYardAutonomousGates;